import { Component } from '@verndale/core';
import datepicker from 'js-datepicker';
import format from 'date-fns/format';
import { nextFrameAsync } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      input: this.el.querySelector('input')
    };

    const picker = datepicker(this.dom.input, {
      formatter: (input, date) => {
        const value = this.formatDate(date);
        input.value = value;
      },
      customDays: ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']
    });

    if (this.dom.input.value.trim()) {
      const dt = new Date(this.dom.input.value);
      // remove timezone
      const dtDateOnly = new Date(
        dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000
      );

      picker.setDate(dtDateOnly);
    }
  }

  addListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this));
  }

  formatDate(date) {
    return `${format(date, 'MM/dd/yyyy')}`;
  }

  async handleClick(e) {
    const calendarNum = e.target.closest('.qs-num');

    if (calendarNum) {
      await nextFrameAsync();
      const event = new Event('keyup');
      this.dom.input.dispatchEvent(event);
    }
  }
}

export default Module;
